// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import licenses from '@/services/licenses.txt';

export function getLicenses(): string {
  return licenses;
}
